import { useState } from 'react';
import { useProfile } from '@/hooks/useProfile.hook';

const WAITING_QUESTS = 'task-waiting';
const DONE_QUESTS = 'task-done';
const CUSTOMER_WAITING_QUESTS = 'task-customer-waiting';

export const useTaskQue = (id: string) => {
  const { profile } = useProfile();
  // const defaultCompletes = useMemo(() => {
  //   // TODO: burasi yeni auth'a gore guncellenmeli
  //   const userConnections: string[] = [
  //     // profile.wallet,
  //     // profile.twitter,
  //     // profile.telegram,
  //     // profile.discord,
  //     // profile.github,
  //   ];
  //   const mainQuestMap: string[] = [
  //     // profile?.completedMainQuests?.wallet || '',
  //     // profile?.completedMainQuests?.twitter || '',
  //     // profile?.completedMainQuests?.telegram || '',
  //     // profile?.completedMainQuests?.discord || '',
  //     // profile?.completedMainQuests?.github || '',
  //   ].filter((a, b) => !!userConnections[b]);
  //
  //   // console.log({ mainQuestMap });
  //
  //   return String(localStorage.getItem(DONE_QUESTS))?.split(',').concat(mainQuestMap);
  // }, [profile]);

  const [que, setQue] = useState(
    profile?.id ? String(localStorage.getItem(WAITING_QUESTS))?.split(',') : [],
  );

  const [customerQueue, setCustomerQueue] = useState(
    profile?.id ? String(localStorage.getItem(CUSTOMER_WAITING_QUESTS))?.split(',') : [],
  );

  const [completes, setCompletes] = useState<string[]>([]);

  const [isWaiting, _setIsWaiting] = useState(que.indexOf(id) >= 0);
  const [isCompleted, _setIsCompleted] = useState(completes.indexOf(id) >= 0);
  const [isCustomerWaiting, _setIsCustomerWaiting] = useState(customerQueue.indexOf(id) >= 0);

  const setIsWaiting = () => {
    // console.log('setIsWaiting', { id });
    const _que = que.concat([id]);
    localStorage.setItem(WAITING_QUESTS, _que.join(','));
    _setIsWaiting(_que.indexOf(id) >= 0);
    // setQue(_que);
  };

  const setIsCustomerWaiting = () => {
    // console.log('setIsWaiting', { id });
    const _que = customerQueue.concat([id]);
    localStorage.setItem(CUSTOMER_WAITING_QUESTS, _que.join(','));
    _setIsWaiting(_que.indexOf(id) >= 0);
    // setQue(_que);
  };

  const setIsCompleted = () => {
    // console.log('setIsCompleted', { id, que, completes }, que.indexOf(id));
    const _que = que.splice(que.indexOf(id), 1);
    const _completes = completes.concat([id]);
    localStorage.setItem(WAITING_QUESTS, _que.join(','));
    localStorage.setItem(DONE_QUESTS, _completes.join(','));
    // setQue(_que);
    // setCompletes(_completes);
    _setIsWaiting(_que.indexOf(id) >= 0);
    _setIsCompleted(_completes.indexOf(id) >= 0);
  };
  const removeFromWaiting = () => {
    const _que = que.splice(que.indexOf(id), 1);
    localStorage.setItem(CUSTOMER_WAITING_QUESTS, _que.join(','));
    _setIsWaiting(_que.indexOf(id) >= 0);
    // setQue(_que);
  };

  const removeFromCustomerWaiting = () => {
    const _que = que.splice(customerQueue.indexOf(id), 1);
    localStorage.setItem(WAITING_QUESTS, _que.join(','));
    _setIsCustomerWaiting(_que.indexOf(id) >= 0);
    // setQue(_que);
  };

  return {
    isWaiting,
    isCompleted,
    isCustomerWaiting,
    setIsWaiting,
    setIsCompleted,
    setIsCustomerWaiting,
    removeFromWaiting,
    removeFromCustomerWaiting,
  };
};
